import React, { Component } from "react";
import { Button, Glyphicon } from "react-bootstrap";
import "../../css/program/CardProgressBar.css";

export default class CardProgressBar extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        return <span className="cardProgressContainer">
                    <span className="cardProgressLabel">
                        Completed: { Math.round(this.props.percentText) }%
                    </span>
                    <span className="cardProgressBarBackground">
                        <div className="cardProgressBar" style={{backgroundColor: "#a4de36", width: this.props.width}}></div>
                    </span>
               </span>
    }
}



// WEBPACK FOOTER //
// ./src/components/program/CardProgressBar.js